

















































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AcgnTitle, AcgnAuditStep, AcgnUpload } from '@acgn/herm/src/ui';
import { AcgnFormContent, AcgnFormTitle } from '@/components/';
import { namespace } from 'vuex-class';
import { complexClone } from '@acgn/herm/src/util/serialize';
import { getComicUploadImageSts } from '@/api/ossClient';

const ComicAction = namespace('desk/comic').Action;
const ComicGetter = namespace('desk/comic').Getter;

interface ComicEditType { // 编辑结构类型
  name: string; // 名称
}

// 组件申明
@Component({
  components: {
    AcgnTitle,
    AcgnAuditStep,
    AcgnFormContent,
    AcgnFormTitle,
    AcgnUpload
  }
})

/**
 * 项目编辑
 */
export default class ComicEdit extends Vue {

  @ComicAction private createComic: any; // 创建漫画
  @ComicAction private updateComic: any; // 编辑漫画
  @ComicGetter private loadings: any; // 漫画loading

  private formData: ComicEditType = {
    name: ''
  };

  private uploadPics: any = { // 图片上传
    shareImg: [] // App列表图
  };
  private uploadLoading: any = { // 图片上传状态
    shareImg: false
  };
  private imgOpts: any = { // 图片上传配置
    shareImg: null
  };

  // 获取表单验证规则
  private get rules() {
    const rules = {
      name: [
        { required: true, message: '标题不可为空', trigger: 'blur' }
      ]
    };

    return rules;
  }

  private created() {
    this.imgOpts.shareImg = {
      action: getComicUploadImageSts, filename: `icon_${+new Date()}.jpg`,
      image_type: 1, handle: true
    };
  }

  // 保存
  private submit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        this.$message.warning(this.$language.formValidateError);
        return;
      }
      try {
        const postData: any = complexClone(this.formData);
        const isCreate: boolean = !postData.comic_id;
        if (isCreate) { // 如果是新增
          const res = await this.createComic(postData);
          this.$message('保存成功，请继续添加封面图');
        } else {
          await this.updateComic(postData);
          this.$message.success('保存成功');
        }
      } catch (ex) {
        this.$message.error(this.$language.error);
      }
    });
  }

  // 返回列表
  private goBack() {
    this.$router.back();
  }
}
